import { call, put, select } from 'redux-saga/effects';
import { sendRetargeting as sendRetargetingAda } from '@gcloud-npm/adabyron.misc.send-retargeting';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* sendRetargeting(params) {
  const { normalizeHttpErrors, reduxUpdate, data, co, logged = false } = params;

  const alreadyLogged = logged || false;

  try {
    const context = yield select(contextStore);
    const response = yield call(sendRetargetingAda, { data, context, logged: alreadyLogged });

    let finalResponse = response;
    if (typeof response === "string") {
      finalResponse = JSON.parse(response);
    }

    if (finalResponse?.retargetingId && reduxUpdate?.successUpdate) {
      yield put(reduxUpdate.successUpdate({ idSE: finalResponse.retargetingId}));
    }

    return response;
  } catch (error) {
    console.log(error);
    const { errorUpdate } = reduxUpdate;

    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.SEND_RETARGETING, error);

    if (typeof co !== 'undefined') {
      return null;
    }

    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
